// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myform-wrapper {
  margin: 50px;
  width: 350px;
}
.myform-wrapper .mat-mdc-form-field {
  width: 100%;
}
.myform-wrapper .mat-toolbar-single-row {
  height: auto !important;
  background: transparent;
}
.myform-wrapper .mat-toolbar-single-row button {
  width: 30%;
}

#fileUpload {
  position: absolute;
  z-index: 9;
  opacity: 0;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/document-library/shared/dialog-add-version/dialog-add-version.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;AACJ;AACI;EACI,WAAA;AACR;AAEI;EACI,uBAAA;EACA,uBAAA;AAAR;AAEQ;EACI,UAAA;AAAZ;;AAKA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;AAFJ","sourcesContent":[".myform-wrapper {\r\n    margin: 50px;\r\n    width: 350px;\r\n\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n\r\n    .mat-toolbar-single-row {\r\n        height: auto !important;\r\n        background: transparent;\r\n\r\n        button {\r\n            width: 30%;\r\n        }\r\n    }\r\n}\r\n\r\n#fileUpload {\r\n    position: absolute;\r\n    z-index: 9;\r\n    opacity: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    left: 0px;\r\n    top: 0px;\r\n    cursor: pointer;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
